"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClearFilterButton = exports.StyledFilterSideMenu = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  right: 0;\n\n  &:hover {\n    cursor: pointer;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  float: left;\n  width: ", ";\n  background: white;\n  padding: 16px 0;\n  border-radius: 10px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledFilterSideMenu = _styledComponents["default"].div(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.sizes.filterColWidth;
});

exports.StyledFilterSideMenu = StyledFilterSideMenu;

var ClearFilterButton = _styledComponents["default"].div(_templateObject2());

exports.ClearFilterButton = ClearFilterButton;

//# sourceMappingURL=styled.js.map